import React from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function RoadmapCheckboxesToggleWrapper(
  props: {
    children: React.ReactNode;
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.ROADMAP_CHECKBOXES}>
      {props.children}
    </ToggleWrapper>
  );
}
